<template>
    <div
        :class="isFullscreen ? 'mr-3 mb-3' : 'mb-3'"
        class="fields-flow-item"
        style="flex-basis: 100%;"
    >
        <div class="global-label">{{ label }}</div>
        <UsersMenu
            ref="assigneesField"
            :value="assignees"
            :items="users"
            :error-messages="errorMessages"
            @change="$emit('change', $event)"
            @keep_only="$emit('keep_only', $event)"
            @tab_next="$emit('tab_next', $event)"
        >
            <template v-slot:pre-menu="{ selectedAccounts, keepOnly, remove }">
                <!--SelectedUsersMobile
                    v-if="isFullscreen"
                    :selected-accounts="selectedAccounts"
                    @keep_only="keepOnly"
                    @remove="remove"
                ></SelectedUsersMobile-->
                <SelectedUsersDesktop
                    :selected-accounts="selectedAccounts"
                    @keep_only="keepOnly"
                    @remove="remove"
                ></SelectedUsersDesktop>
            </template>
            <template v-slot:default="{ selectedAccounts, on }">
                <AddUserButton v-on="on"></AddUserButton>
            </template>
        </UsersMenu>
    </div>
</template>

<script>
import UsersMenu from "@/components/UsersField/UsersMenu";
import SelectedUsersMobile from "@/components/UsersField/SelectedUsersMobile";
import SelectedUsersDesktop from "@/components/UsersField/SelectedUsersDesktop";
import AddUserButton from "../../../components/UsersField/AddUserButton";
import { $t } from "@/i18n";

export default {
    name: "TaskAssignees",
    components: {
        UsersMenu,
        SelectedUsersMobile,
        SelectedUsersDesktop,
        AddUserButton
    },
    props: {
        users: {
            type: Array,
            default: () => []
        },
        assignees: {
            type: Array,
            default: () => []
        },
        errorMessages: {
            type: String,
            default: null
        },
        isFullscreen: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: () => $t("Members")
        }
    },
    setup() {
        return {}
    }
}
</script>
